import { useState } from "react";

import { Button, Text, toastError } from "@alpacahq/ui/old";

import { FullScreenSpinner } from "~/v2/components/common";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { fetchAccountAgreement } from "../../api/rest/account";
import { acceptW8 } from "../../api/rest/onboarding";
import Page from "../../components/common/page";
import App from "../index";

const W8BEN = () => {
  // TODO (MLA): If support directs user to this page via direct link, we need to
  // ensure that the correct account is displayed.
  // We also need to check if the W8BEN really belongs to the account or the party.
  const { currentAccount } = useAccountContext({ liveOnly: true });

  const [success, setSuccess] = useState(false);
  const [viewedW8, setViewedW8] = useState(false);

  if (!currentAccount?.id) {
    return <FullScreenSpinner />;
  }

  const fetchW8Link = () => {
    fetchAccountAgreement(currentAccount?.id, "w_8ben").then((resp) => {
      const binaryData = [];

      binaryData.push(resp);

      const fileURL = window.URL.createObjectURL(
        new Blob(binaryData, { type: "application/pdf" }),
      );

      window.open(fileURL);
    });

    setViewedW8(true);
  };

  const certify = () =>
    acceptW8(currentAccount.id)
      .then(() => setSuccess(true))
      .catch((err) => toastError(`Error accepting W8: ${err?.message}`));

  return (
    <App>
      <Page>
        <div className="mx-auto w-full max-w-[600px] p-4">
          {success ? (
            <div className="flex flex-col gap-4">
              <Text className="font-semibold text-xl">W8-BEN Signed</Text>
              <Text className="text-lg">
                You have successfully signed the W8-BEN agreement and may close
                this page anytime.
              </Text>
            </div>
          ) : (
            <>
              <Text className="font-semibold text-xl">
                Please read and agree to the W-8BEN form:
              </Text>
              <div className="flex flex-col gap-4 py-8 text-gray-600">
                <Text>
                  Under penalties of perjury, I declare that I have examined the
                  information on this form and to the best of my knowledge and
                  belief it is true, correct, and complete. I further certify
                  under penalties of perjury that:
                </Text>
                <Text>
                  I am the individual that is the beneficial owner (or am
                  authorized to sign for the individual that is the beneficial
                  owner) of all the income to which this form relates or am
                  using this form to document myself for chapter 4 purposes,
                </Text>
                <Text>
                  The person named on line 1 of this form is not a U.S. person,
                  The income to which this form relates is: (a) not effectively
                  connected with the conduct of a trade or business in the
                  United States, (b) effectively connected but is not subject to
                  tax under an applicable income tax treaty, or (c) the
                  partner's share of a partnership&apos;s effectively connected
                  income, The person named on line 1 of this form is a resident
                  of the treaty country listed on line 9 of the form (if any)
                  within the meaning of the income tax treaty between the United
                  States and that country, and For broker transactions or barter
                  exchanges, the beneficial owner is an exempt foreign person as
                  defined in the instructions.
                </Text>
                <Text>
                  Furthermore, I authorize this form to be provided to any
                  withholding agent that has control, receipt, or custody of the
                  income of which I am the beneficial owner or any withholding
                  agent that can disburse or make payments of the income of
                  which I am the beneficial owner. I agree that I will submit a
                  new form within 30 days if any certification made on this form
                  becomes incorrect.
                </Text>
                <Text>
                  I confirm and certify that the information on the above
                  referenced W-8BEN is accurate and correct and that I
                  understand that by clicking on &ldquo;I Certify&ldquo; below,
                  I am electronically signing the W-8BEN.
                </Text>
              </div>
              <Button
                variant="alternate"
                className="mr-1 mb-4 w-full"
                disabled={viewedW8}
                onClick={() => fetchW8Link()}
              >
                View W-8BEN
              </Button>
              <Button
                className="mr-1 mb-4 w-full"
                disabled={!viewedW8}
                onClick={() => certify()}
              >
                I Certify
              </Button>
            </>
          )}
        </div>
      </Page>
    </App>
  );
};

export default W8BEN;
